import React, {useState, useEffect, useCallback} from 'react'
import DataTable from 'react-data-table-component';
import { TeamsDB } from '../db/TeamsDB'
import { Link } from 'react-router-dom';
import { Utils } from '../utils/Utils';
import Modal from '../utils/Modal';
import Select from "react-select";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import './Searcher.css'

function Searcher() {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [teams, setTeams] = useState([])
  const [players, setPlayers] = useState([])
  const [playersFiltered, setPlayersFiltered] = useState([])
  const [errorMsg, setErrorMsg] = useState('')
  const [selectedTeams, setSelectedTeams] = useState([])
  const [selectedPositions, setSelectionPositions] = useState([])
  const [selectedLicences, setSelectedLicences] = useState([])
  const [selectedNationalities, setSelectedNationalities] = useState([])
  const [selectedLeagues, setSelectedLeagues] = useState([])
  const [nationalities, setNationalities] = useState([])
  const [leagues, setLeagues] = useState([]);
  const [rangeHeight, setRangeHeight] = useState([0, 250]);
  const [minHeight, setMinHeight] = useState(0);
  const [maxHeight, setMaxHeight] = useState(250);
  const [rangeAge, setRangeAge] = useState([0, 100]);
  const [minAge, setMinAge] = useState(0);
  const [maxAge, setMaxAge] = useState(100);
  const [rangePoints, setRangePoints] = useState([0, 40]);
  const [rangeRebounds, setRangeRebounds] = useState([0, 20]);
  const [rangeAssists, setRangeAssists] = useState([0, 20]);
  const [filterText, setFilterText] = useState('');

  const PAGE_SIZE = 10;
  const MIN_POINTS = 0;
  const MAX_POINTS = 40;
  const MIN_REBOUNDS = 0;
  const MAX_REBOUNDS = 20;
  const MIN_ASSISTS = 0;
  const MAX_ASSISTS = 20;

  const search = () => {
    const filterPlayers = {}
    setPlayersFiltered([...players]); 
    if (selectedTeams.length > 0) {
      filterPlayers.teams = selectedTeams.map(team => team.label);
    } 
    if (selectedPositions.length > 0) {
      filterPlayers.positions = selectedPositions.map(position => position.value);
    }
    if (selectedLicences.length > 0) {
      filterPlayers.licences = selectedLicences.map(licence => licence.value);
    }
    if (selectedNationalities.length > 0) {
      filterPlayers.nationalities = selectedNationalities.map(nationality => nationality.value);
    }
    if (rangeHeight[0] !== 0  || rangeHeight[1] !== 250) {
      filterPlayers.height = rangeHeight;
    }
    if (rangeAge[0] !== 0 || rangeAge[1] !== 100) {
      filterPlayers.age = rangeAge;
    }
    if (selectedLeagues.length > 0) {
      filterPlayers.leagues = selectedLeagues.map(league => league.value);
    }
    if (rangePoints[0] !== 0 || rangePoints[1] !== 40) {
      filterPlayers.points = rangePoints;
    }
    if (rangeRebounds[0] !== 0 || rangeRebounds[1] !== 20) {
      filterPlayers.rebounds = rangeRebounds;
    }
    if (rangeAssists[0] !== 0 || rangeAssists[1] !== 20) {
      filterPlayers.assists = rangeAssists;
    }
    applyFilter(filterPlayers, teams)
    setIsModalOpen(false)
  }

  const formatPlayers = playersTmp => {
    playersTmp.forEach(player => {
      if (typeof player.position === "number") {
        player.position = String(player.position);
      }
    });

    return playersTmp.map(player => ({
      ...player,
      age: Utils.getAge(player.birthDate),
      pointsPerGame: Utils.decimalDiv(player.points, player.numMatches, 1),
      reboundsPerGame: Utils.decimalDiv(player.rebounds, player.numMatches, 1),
      assistsPerGame: Utils.decimalDiv(player.assists, player.numMatches, 1)
    }))
  }

  const applyFilter = useCallback((filterPlayers, teams) => {

    const showFilterText = (filter) => {
      let text = [];
      if (filter.teams && filter.teams.length > 0) { 
        text.push(`Equipos: ${filter.teams.join(', ')}`);
      }
      if (filter.positions && filter.positions.length > 0) {
        text.push(`Posiciones: ${filter.positions.map(pos => Utils.getPositionById(pos).position.name).join(', ')}`);
      }
      if (filter.licences && filter.licences.length > 0) {
        text.push(`Licencias: ${filter.licences.map(lic => Utils.getLicence(lic)).join(', ')}`);
      }
      if (filter.nationalities && filter.nationalities.length > 0) {
        text.push(`Nacionalidades: ${filter.nationalities.join(', ')}`);
      }
      if (filter.height && filter.height.length === 2 && (filter.height[0] !== minHeight || filter.height[1] !== maxHeight)) {
        text.push(`Altura: ${filter.height[0]} cm - ${filter.height[1]} cm`);
      }
      if (filter.age && filter.age.length === 2 && (filter.age[0] !== minAge || filter.age[1] !== maxAge)) {
        text.push(`Edad: ${filter.age[0]} años - ${filter.age[1]} años`);
      }
      if (filter.leagues && filter.leagues.length > 0) {
        text.push(`Ligas: ${filter.leagues.map(league => Utils.formatLeague(league)).join(', ')}`);
      }
      if (filter.points && filter.points.length === 2 && (filter.points[0] !== MIN_POINTS || filter.points[1] !== MAX_POINTS)) {
        text.push(`Puntos pp: ${filter.points[0]} - ${filter.points[1]}`);
      }
      if (filter.rebounds && filter.rebounds.length === 2 && (filter.rebounds[0] !== MIN_REBOUNDS || filter.rebounds[1] !== MAX_REBOUNDS)) {
        text.push(`Rebotes pp: ${filter.rebounds[0]} - ${filter.rebounds[1]}`);
      }
      if (filter.assists && filter.assists.length === 2 && (filter.assists[0] !== MIN_ASSISTS || filter.assists[1] !== MAX_ASSISTS)) {
        text.push(`Asistencias pp: ${filter.assists[0]} - ${filter.assists[1]}`);
      }
      setFilterText(text.join(' | '));
    }

    let playersTmp = teams.map(team => team.players).flat().filter(player => player !== undefined).sort((a, b) => a.name.localeCompare(b.name))
    if (filterPlayers?.teams?.length > 0) {
      const teamsFiltered = teams.filter(team => filterPlayers.teams.includes(team.name));
      playersTmp = teamsFiltered.map(team => team.players).flat().filter(player => player !== undefined).sort((a, b) => a.name.localeCompare(b.name));
    } 
    playersTmp = formatPlayers(playersTmp);
    if (filterPlayers?.positions?.length > 0) {
      const positionsFiltered = Utils.addDoublePositions(filterPlayers.positions)
      playersTmp = playersTmp.filter(player => positionsFiltered.includes(player.position));
    }
    if (filterPlayers?.licences?.length > 0) {
      playersTmp = playersTmp.filter(player => filterPlayers.licences.includes(player.licence));
    }
    if (filterPlayers?.nationalities?.length > 0) {
      playersTmp = playersTmp.filter(player => filterPlayers.nationalities.includes(player.nationality) || (player.nationality2 && filterPlayers.nationalities.includes(player.nationality2)));
    } 
    if (filterPlayers?.height) {
      playersTmp = playersTmp.filter(player => (player.height * 100) >= filterPlayers.height[0] && (player.height * 100) <= filterPlayers.height[1]);
    } 
    if (filterPlayers?.age) {
      playersTmp = playersTmp.filter(player => player.age >= filterPlayers.age[0] && player.age <= filterPlayers.age[1]);
    }
    if (filterPlayers?.leagues?.length > 0) {
      playersTmp = playersTmp.filter(player => filterPlayers.leagues.includes(player.categoryLastTeam+"_"+player.countryLastTeam));
    }
    if (filterPlayers?.points) {
      playersTmp = playersTmp.filter(player => player.pointsPerGame >= filterPlayers.points[0] && player.pointsPerGame <= filterPlayers.points[1]);
    }
    if (filterPlayers?.rebounds) {
      playersTmp = playersTmp.filter(player => player.reboundsPerGame >= filterPlayers.rebounds[0] && player.reboundsPerGame <= filterPlayers.rebounds[1]);
    }
    if (filterPlayers?.assists) {
      playersTmp = playersTmp.filter(player => player.assistsPerGame >= filterPlayers.assists[0] && player.assistsPerGame <= filterPlayers.assists[1]);
    }
    setPlayersFiltered(playersTmp);
    showFilterText(filterPlayers);
    localStorage.setItem("filterPlayers", JSON.stringify(filterPlayers))
  }, [maxAge, minAge, maxHeight, minHeight]);

  useEffect(() => {
    const setFilter = () => {
      const filterPlayers = localStorage.getItem("filterPlayers");
      if (filterPlayers) {
        const filter = JSON.parse(filterPlayers);
        if (filter.teams && filter.teams.length > 0) {
          setSelectedTeams(filter.teams.map(team => ({ value: team, label: team })));
        }
        if (filter.positions && filter.positions.length > 0) {
          setSelectionPositions(filter.positions.map(position => ({ value: position, label: Utils.getPositionById(position).position.name })));
        }
        if (filter.licences && filter.licences.length > 0) {
          setSelectedLicences(filter.licences.map(licence => ({ value: licence, label: Utils.getLicence(licence) })));
        }
        if (filter.nationalities && filter.nationalities.length > 0) {
          setSelectedNationalities(filter.nationalities.map(nationality => ({value: nationality, label: nationality})))
        }
        if (filter.height && filter.height.length === 2) {
          setRangeHeight(filter.height);
        }
        if (filter.age && filter.age.length === 2) {
          setRangeAge(filter.age);
        }
        if (filter.leagues && filter.leagues.length > 0) {
          setSelectedLeagues(filter.leagues.map(league => ({ value: league, label: Utils.formatLeague(league) })));
        }
        if (filter.points && filter.points.length === 2) {
          setRangePoints(filter.points);
        }
        if (filter.rebounds && filter.rebounds.length === 2) {
          setRangeRebounds(filter.rebounds);
        }
        if (filter.assists && filter.assists.length === 2) {
          setRangeAssists(filter.assists);
        }
        return filter
      }
      return null
    }

    const initNationalities = (dataPlayers) => {
      const nationalitySet = new Set();
      dataPlayers.forEach(player => {
        if (player.nationality) {
          nationalitySet.add(player.nationality);
        }
        if (player.nationality2) {
          nationalitySet.add(player.nationality2);
        }
      });
      setNationalities([...nationalitySet].sort((a,b)=> a.localeCompare(b)));
    }

    const initHeights = (dataPlayers) => {
      const minHt = parseInt((Math.min(...dataPlayers.map(player => player.height)))*100)
      const maxHt = parseInt((Math.max(...dataPlayers.map(player => player.height)))*100)
      setMinHeight(minHt);
      setMaxHeight(maxHt); 
      setRangeHeight([minHt, maxHt]);
    }

    const initAges = (dataPlayers) => {
      const minAg = Math.min(...dataPlayers.map(player => player.age));
      const maxAg = Math.max(...dataPlayers.map(player => player.age));
      setMinAge(minAg);
      setMaxAge(maxAg);
      setRangeAge([minAg, maxAg]);
    }

    const initLeagues = (dataPlayers) => {
      const leaguesSet = new Set();
      dataPlayers.forEach(player => {
        if (player.categoryLastTeam) {
          leaguesSet.add(player.categoryLastTeam+"_"+player.countryLastTeam);
        }
      });
      setLeagues([...leaguesSet].sort((a, b) => a.localeCompare(b)));
    }

    TeamsDB.getFromPrimeraFEB(true).then((teamsData) => {
      if (teamsData) {
        setTeams(teamsData);
        let dataPlayers = teamsData.map(team => team.players).flat().filter(player => player !== undefined).sort((a, b) => a.name.localeCompare(b.name));
        dataPlayers = dataPlayers.map(player => ({
          ...player,
          age: Utils.getAge(player.birthDate)
        }))
        setPlayers(dataPlayers);
        initNationalities(dataPlayers);
        initHeights(dataPlayers);
        initAges(dataPlayers);
        initLeagues(dataPlayers);
        const filterPlayers = setFilter();
        if (filterPlayers) {
          applyFilter(filterPlayers, teamsData);
        } else {
          setPlayersFiltered(dataPlayers);
        }
      } else {
        setErrorMsg('No se han encontrado equipos en la Primera FEB');
      }
    }).catch((error) => {
      setErrorMsg(error.message || 'Ha ocurrido un error al cargar los equipos');
    });
    
  },[applyFilter])

  

  const resetForm = () => {
    setSelectedTeams([]);
    setSelectionPositions([]);
    setSelectedLicences([]);
    setSelectedNationalities([]);
    setRangeHeight([minHeight, maxHeight]);
    setRangeAge([minAge, maxAge]);
    setSelectedLeagues([]);
    setFilterText('');
    setRangePoints([0, 40]);
    setRangeRebounds([0, 20]);
    setRangeAssists([0, 20]);
    localStorage.removeItem("filterPlayers");
  }

  const columns = [
    {
      name: 'Equipo',
      cell: row => getLogoTeam(row['team']),
      ignoreRowClick: true,
      width: '80px',
      center: true
    },
    {
      name: 'Posición',
      cell: row => Utils.getPositionById(row['position']) != null ? Utils.getPositionById(row['position']).position.abr : '',
      ignoreRowClick: true,
      width: '80px',
      center: true
    },
    {
      cell: row => <Link to="/player" state={{ idPlayer: row.id, idTeam: row.team }}>{row.name}</Link>,
      name: 'Nombre',
      ignoreRowClick: true
    }

    
  ];

  const getLogoTeam = id => {
    const teamsFiltered = teams.filter(team => id === team.id)
    if (teamsFiltered.length === 1) {
      return <img className="logo-team-small" src={teamsFiltered[0].url_logo} alt={teamsFiltered[0].url_logo}></img>
    } 
    return ""
  }

  return (
    <div className="searcher-container">
      <div className="header" id="header-searcher"><h2>Buscador de Jugadores</h2></div>
      <div className="container-searcher">
        <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
          <div className="filter">
            <h2>Filtro</h2>
            <div className="form-field">
              <Select
                classNamePrefix="roster-select"
                options={teams.map(team => ({ value: team.id, label: team.name }))}
                isMulti
                value={selectedTeams}
                onChange={setSelectedTeams}
                placeholder="Equipos"
              />
            </div>
            <div className="form-field">
              <Select
                classNamePrefix="roster-select"
                options={Utils.positions.filter(position => position.id.length < 2)
                  .map(position => ({ value: position.id, label: position.position.name }))}
                isMulti
                value={selectedPositions}
                onChange={setSelectionPositions}
                placeholder="Posiciones"
              />
            </div>
            <div className="form-field">
              <Select
                classNamePrefix="roster-select"
                options={Utils.licences.map(licence => ({ value: licence.abr, label: licence.name }))}
                isMulti
                value={selectedLicences}
                onChange={setSelectedLicences}
                placeholder="Licencias"
              />
            </div>
            <div className="form-field">
            <Select
              classNamePrefix="roster-select"
              options={nationalities.map(nationality => ({ value: nationality, label: nationality }))}
              isMulti
              value={selectedNationalities}
              onChange={setSelectedNationalities}
              placeholder="Nacionalidades"
            />
            </div>
            <div className="form-field">
              <label className="block mb-2 text-lg font-semibold">Altura (cm)</label>
              <Slider
                range
                min={minHeight}
                max={maxHeight}
                value={rangeHeight}
                onChange={setRangeHeight}
                allowCross={false}
                step={1}
              />
              <div className="mt-2 text-sm">
                Seleccionado: {rangeHeight[0]} cm - {rangeHeight[1]} cm
              </div>
            </div>
            <div className="form-field">
              <label className="block mb-2 text-lg font-semibold">Edad (años)</label>
              <Slider
                range
                min={minAge}
                max={maxAge}
                value={rangeAge}
                onChange={setRangeAge}
                allowCross={false}
                step={1}
              />
              <div className="mt-2 text-sm">
                Seleccionado: {rangeAge[0]} años - {rangeAge[1]} años
              </div>
            </div>
            <div className="form-field">
              <label>Temporada anterior</label>
            </div>
            <div className="form-field">
              <Select
                classNamePrefix="roster-select"
                options={leagues.map(league => ({ value: league, label: Utils.formatLeague(league) }))}
                isMulti
                value={selectedLeagues}
                onChange={setSelectedLeagues}
                placeholder="Ligas de procedencia"
              />
            </div>
            <div className="form-field">
              <label className="block mb-2 text-lg font-semibold">Puntos pp</label>
              <Slider
                range
                min={MIN_POINTS}
                max={MAX_POINTS}
                value={rangePoints}
                onChange={setRangePoints}
                allowCross={false}
                step={1}
              />
              <div className="mt-2 text-sm">
                Seleccionado: {rangePoints[0]} ppp - {rangePoints[1]} ppp
              </div>
            </div>
            <div className="form-field">
              <label className="block mb-2 text-lg font-semibold">Rebotes pp</label>
              <Slider
                range
                min={MIN_REBOUNDS}
                max={MAX_REBOUNDS}
                value={rangeRebounds}
                onChange={setRangeRebounds}
                allowCross={false}
                step={1}
              />
              <div className="mt-2 text-sm">
                Seleccionado: {rangeRebounds[0]} rpp - {rangeRebounds[1]} rpp
              </div>
            </div>
            <div className="form-field">
              <label className="block mb-2 text-lg font-semibold">Asistencias pp</label>
              <Slider
                range
                min={MIN_ASSISTS}
                max={MAX_ASSISTS}
                value={rangeAssists}
                onChange={setRangeAssists}
                allowCross={false}
                step={1}
              />
              <div className="mt-2 text-sm">
                Seleccionado: {rangeAssists[0]} app - {rangeAssists[1]} app
              </div>
            </div>
            <div className="buttons">
              <button className="btn btn-primary" onClick={search}>Buscar</button>
              <button className="btn btn-primary" onClick={resetForm}>Limpiar</button>
            </div>
          </div>
        </Modal>
        <div className="searcher-header">
          <button className="btn btn-primary" onClick={() => setIsModalOpen(true)}>Filtrar</button>
          
        </div>
        <div className="searcher-filter-text">
          {filterText && <span><strong>Resultados para: </strong>{filterText}</span>}
        </div>
        <div className="table-players">
          <DataTable
            columns={columns}
            data={playersFiltered}
            noDataComponent="No se han encontrado jugadores"
            pagination
            paginationTotalRows={playersFiltered.length}
            paginationPerPage={PAGE_SIZE}
            paginationRowsPerPageOptions={[PAGE_SIZE]}
        />
        </div>
      {errorMsg}
      </div>
    </div>
  )
}

export default Searcher